import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const NoPage = createIcon({
  displayName: 'NoPage',
  viewBox: '0 0 54 59',
  path: [
    <svg key="noPage">
      <path
        d="M53.5065 54.507L4.49321 5.49366L0.706543 9.25366L4.99988 13.547V48.667C4.99988 51.6003 7.39988 54.0003 10.3332 54.0003H45.4532L49.7465 58.2937L53.5065 54.507ZM10.3332 48.667V18.8803L40.1199 48.667H10.3332ZM42.3332 19.3337V11.3337H47.6665V41.1203L52.9999 46.4537V11.3337C52.9999 8.40032 50.5999 6.00033 47.6665 6.00033H36.5199C35.3999 2.90699 32.4665 0.666992 28.9999 0.666992C25.5332 0.666992 22.5999 2.90699 21.4799 6.00033H12.5465L25.8799 19.3337H42.3332ZM28.9999 6.00033C30.4665 6.00033 31.6665 7.20033 31.6665 8.66699C31.6665 10.1337 30.4665 11.3337 28.9999 11.3337C27.5332 11.3337 26.3332 10.1337 26.3332 8.66699C26.3332 7.20033 27.5332 6.00033 28.9999 6.00033Z"
        fill="#3A3A3C"
      />
    </svg>,
  ],
})
